<template lang="pug">
.v-field-currency.field-currency(:class="['field-currency--' + view, {'field-currency--open': open}]")
	label.field-currency__label(v-if="field.label" :for="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	button.field-currency__btn(type="button" @click="open = !open" :id="uniqueId" :disabled="field.disabled" :class="{'open': open}")
		img.field-currency__btn-icon(v-if="activeOption" :src="activeOption.icon")
		span.field-currency__btn-placeholder(v-if="!activeOption && field.placeholder" key="placeholder") {{field.placeholder}}
		span.field-currency__btn-text(v-else-if="activeOption" key="text") {{activeOption.text}}
		v-svg-icon.field-currency__btn-arrow(icon="select-arrow")
	.field-currency__list(v-show="open" :class="{'open': open}" @click="open = false;")
		.field-currency__list-container
			template(v-for="(option, index) in field.options" :key="index")
				button.field-currency__list-item(type="button"
						@click="handlerInput(option)"
						:class="{'active': option.value === activeOption?.value}")
					img.field-currency__list-item-icon(:src="option.icon")
					span.field-currency__list-item-text {{option.text}}
					v-svg-icon.field-currency__list-item-arrow(v-if="activeOption && option.value === activeOption.value" icon="tik")
	select.field-currency__select(v-if="isTablet" @change="handlerSelectChange($event)")
		option(v-for="(option, index) in field.options" :key="index" :value="option.value" :selected="option.value === activeOption.value") {{option.text}}
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		isMobMixin
	],

	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: [Object, String, Number, Boolean, Symbol, Date],
			default: null
		},

		view: {
			type: String,
			default: 'regular'
		}
	},

	emits: [
		'update:model-value'
	],
	
	data() {
		return {
			localValue: null,
			open: false,
			uniqueId: uniqueId('field-currency_'),
			selectValueText: '',
		};
	},

	computed: {
		activeOption() {
			if (this.field && this.field.options && this.field.options.length) {
				return this.field.options.find(option => option.value === this.localValue);
			}
			return null;
		}
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
		document.addEventListener('click', this.handlerClickOutside);
		document.addEventListener('keydown', this.handlerEsc);
	},

	unmounted() {
		document.removeEventListener('click', this.handlerClickOutside);
		document.removeEventListener('keydown', this.handlerEsc);
	},

	methods: {

		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handlerInput(option) {
			this.localValue = option.value;
			this.$emit('update:model-value', this.localValue);
			this.open = false;
		},

		handlerClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.open = false;
			}
		},

		handlerEsc(e) {
			if (e.keyCode == 27 && this.open) {
				e.stopPropagation();
				this.open = false;
			}
		},

		handlerSelectChange(e) {
			this.localValue = e.target.value;
			this.$emit('update:model-value', this.localValue);
		}
	}
};
</script>
